/* global localStorage */

import axios from 'axios'
import APP_CONFIG from '@/config/config.js';

export default axios.create({
  baseURL: APP_CONFIG.API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  }
})